<template>
  <Loading v-if="!fullyLoaded" />
  <Form
    v-else
    :chemicals="chemicals"
    :plantUsers="plantUsers"
    :resource="resource"
    :destroy="destroy"
    :submit="submit"
    :cancel="cancel"
  />
</template>

<script>
import _ from 'lodash';

import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/applications_service';
import ChemicalCostService from '@/services/resources/chemical_costs_service';
import PlantUserService from '@/services/resources/plant_users_service';
import AppStepService from '@/services/resources/application_steps_service';
import AppPermissionService from '@/services/resources/application_permissions_service';

export default {
  mixins: [EditView],
  components: {
    Form: () => import('@/components/forms/ApplicationForm.vue'),
  },
  data() {
    return {
      resourceParams: {
        include: 'app-steps,app-steps.chemical,app-permissions,app-permissions.plant-user,site',
      },
      urlFragment: 'applications',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    chemicals: {
      get() {
        const options = {
          include: 'chemical',
          filter: {
            site: this.siteId,
          },
        };
        return ChemicalCostService.index(options).then((costs) => {
          const chemicals = _.uniq(
            costs.data.map((cost) => {
              const { chemical } = cost;
              if (cost.deletedAt && !chemical.disabled) {
                chemical.name += ' [Deleted]';
                chemical.disabled = true;
              }

              return chemical;
            }),
          );
          // Get this from the server probably?
          chemicals.push({
            id: '-2',
            name: 'Water',
            ppg: 8.34,
            type: 'chemicals',
          });

          return _.sortBy(chemicals, 'name');
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
    plantUsers: {
      get() {
        const options = {
          filter: {
            site: this.siteId,
          },
        };
        return PlantUserService.index(options).then((plantUsers) => {
          return plantUsers.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
  methods: {
    submit(resource) {
      const { appSteps, appPermissions, ...appAttributes } = resource;
      appAttributes.replacing = true;
      appAttributes.parentId = appAttributes.id;
      delete appAttributes.id;
      return this.resourceService
        .create(appAttributes) // FIXME: Is create the wrong thing here? Should we be using update?
        .then((app) => {
          const stepPromises = _.compact(
            appSteps.map((step) => {
              delete step.id;
              step.app = app.data;
              return !step.toDelete && AppStepService.create(step);
            }),
          );

          const permissionPromises = appPermissions.map((permission) => {
            delete permission.id;
            permission.uses = permission.uses || 0;
            permission.app = app.data;
            return AppPermissionService.create(permission);
          });

          return Promise.all([...stepPromises, ...permissionPromises]).then(async () => {
            await this.resourceService.destroy(resource);
            const { name } = app.data;
            this.successToast(`Updated ${name}`);
            this.$router.push(this.destination);
          });
        })
        .catch(this.failToast);
    },
  },
};
</script>
